import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { mediaQueries } from '../../../styles/media-queries';
import { Input, Button as StyledButton } from '../styles';
import { Flexbox } from '../../Flexbox';

export const GetStartedWrapper = styled(Flexbox)`
  position: relative;
  height: 100%;
  width: fit-content;
  align-self: center;
`;

export const GetStartedInput = styled(Input, {
  shouldForwardProp: (prop) => prop !== 'isScrolled'
})<{ isScrolled?: boolean }>`
  width: 100%;
  flex: 1 1 auto;
  align-self: center;
  padding: ${({ theme, isScrolled }) =>
    isScrolled ? `${theme.spacing.sm} ${theme.spacing.m}` : theme.spacing.ml};
  padding-right: ${({ theme, isScrolled }) =>
    isScrolled ? theme.spacing.xl : theme.spacing['2xl']};
  border: ${({ theme }) => `${pxToRem(1)} solid ${theme.cfColor.green}`};
  overflow: hidden;
  opacity: 1;

  transition: flex-grow 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);

  ${({ isScrolled, theme }) => `
    height: ${isScrolled ? pxToRem(40) : pxToRem(64)};
    width: ${isScrolled ? pxToRem(224) : pxToRem(286)};
    border-radius: ${
      isScrolled
        ? theme.borderRadius.input_mobile_nav
        : theme.borderRadius.input_desktop
    };
    
    font-size: ${isScrolled ? theme.fontSize.s : theme.fontSize.m};

    ::placeholder {
      font-size: ${isScrolled ? theme.fontSize.s : theme.fontSize.m};
    }
  `}

  ${mediaQueries[0]} {
    ${({ isScrolled, theme }) => `
      width: ${isScrolled ? pxToRem(174) : pxToRem(252)};
      font-size: ${isScrolled ? theme.fontSize['2xs'] : theme.fontSize.s};

      padding: ${
        isScrolled ? `${theme.spacing.sm} ${theme.spacing.s}` : theme.spacing.m
      };
      padding-right: ${isScrolled ? theme.spacing.l : theme.spacing.xl};

      ::placeholder {
        font-size: ${isScrolled ? theme.fontSize['2xs'] : theme.fontSize.sm};
      }
    `}
  }

  ${mediaQueries.desktop} {
    height: ${pxToRem(64)};
    width: ${pxToRem(286)};
    font-size: ${({ theme }) => theme.fontSize.m};
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
    ::placeholder {
      font-size: ${({ theme }) => theme.fontSize.m};
    }
  }
`;

export const GetStartedButton = styled(StyledButton, {
  shouldForwardProp: (prop) => prop !== 'isScrolled'
})<{ isScrolled?: boolean }>`
  z-index: 1;
  flex: 1 1 auto;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  min-width: fit-content;
  -webkit-tap-highlight-color: transparent;

  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 1.01);
  will-change: width, flex-grow;

  ${({ isScrolled, theme }) => `
    font-size: ${isScrolled ? theme.fontSize.s : theme.fontSize.sm};
    height: ${isScrolled ? pxToRem(40) : pxToRem(56)};
    min-height: ${pxToRem(32)};
    width: ${isScrolled ? pxToRem(104) : pxToRem(286)};
    border-radius: ${
      isScrolled
        ? theme.borderRadius.input_mobile_nav
        : theme.borderRadius.input_desktop
    };
  `}
  

  ${mediaQueries.desktop} {
    height: ${pxToRem(64)};
    width: ${pxToRem(286)};
    font-size: ${({ theme }) => theme.fontSize.sm}
    border-radius: ${({ theme }) => theme.borderRadius.input_desktop};
  }
`;

export const GetStartedIconBtn = styled(GetStartedButton)`
  padding: ${({ theme }) => `0 ${theme.spacing.s}`};
  margin: auto 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;

  &:hover,
  :focus,
  :active {
    color: rgba(0, 0, 0, 0);
  }

  ${({ isScrolled, theme }) => `
    height: ${isScrolled ? pxToRem(32) : pxToRem(48)};
    width: ${isScrolled ? pxToRem(32) : pxToRem(48)};
    border-radius: ${
      isScrolled ? theme.borderRadius.input_button : theme.borderRadius.button
    };
  `}

  ${mediaQueries[0]} {
    margin: ${({ theme, isScrolled }) =>
      isScrolled ? `auto 2.5%` : `auto ${theme.spacing.s}`};
  }

  ${mediaQueries.mobile} {
    margin: ${({ theme, isScrolled }) =>
      isScrolled ? `auto 2%` : `auto ${theme.spacing.s}`};
  }

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.button};
    height: ${pxToRem(48)};
    max-height: ${pxToRem(48)};
    width: ${pxToRem(48)};
    min-width: ${pxToRem(48)};
    margin: ${({ theme }) => `auto ${theme.spacing.s}`};
  }
`;
